
const StatisticsCards = () => {
  return (
    <>
      <div className="grid grid-cols-2 gap-2">
        <div className="bg-white/50 rounded-xl p-3 text-center border border-purple-100 relative overflow-hidden">
          <div className="relative">
            {/* Animated circular progress for Days Strong */}
            <div className="relative w-12 h-12 mx-auto mb-2">
              <svg className="w-12 h-12 transform -rotate-90" viewBox="0 0 36 36">
                <circle
                  cx="18"
                  cy="18"
                  r="16"
                  stroke="currentColor"
                  strokeWidth="2"
                  fill="none"
                  className="text-purple-100"
                />
                <circle
                  cx="18"
                  cy="18"
                  r="16"
                  stroke="currentColor"
                  strokeDasharray="33.33"
                  strokeDashoffset="23.33"
                  strokeWidth="2"
                  fill="none"
                  className="text-purple-500"
                  style={{
                    animation: 'dashArray 2s ease-in-out infinite alternate'
                  }}
                />
              </svg>
              <div className="absolute inset-0 flex items-center justify-center">
                <span className="text-xl font-black text-purple-600 animate-bounce flex items-center justify-center w-full h-full">7</span>
              </div>
            </div>
            <div className="text-xs font-semibold text-gray-600">Days Strong</div>
          </div>
        </div>
        
        <div className="bg-white/50 rounded-xl p-3 text-center border border-purple-100 relative overflow-hidden">
          <div className="relative">
            {/* Animated bar chart for Days Left */}
            <div className="relative w-12 h-12 mx-auto mb-2 flex items-end justify-center gap-1">
              <div className="w-2 bg-yellow-300 rounded-t animate-pulse" 
                   style={{ height: '20px', animationDelay: '0s' }}></div>
              <div className="w-2 bg-yellow-400 rounded-t animate-pulse" 
                   style={{ height: '32px', animationDelay: '0.2s' }}></div>
              <div className="w-2 bg-yellow-500 rounded-t animate-pulse" 
                   style={{ height: '28px', animationDelay: '0.4s' }}></div>
              <div className="w-2 bg-orange-400 rounded-t animate-pulse" 
                   style={{ height: '36px', animationDelay: '0.6s' }}></div>
            </div>
            <div className="absolute top-1 right-1">
              <span className="text-lg font-black text-yellow-500 animate-bounce" 
                    style={{ animationDelay: '0.3s' }}>14</span>
            </div>
            <div className="text-xs font-semibold text-gray-600">Days Left</div>
          </div>
        </div>
      </div>

      {/* Custom CSS for animations */}
      <style>{`
        @keyframes dashArray {
          0% {
            stroke-dashoffset: 33.33;
          }
          50% {
            stroke-dashoffset: 16.66;
          }
          100% {
            stroke-dashoffset: 10;
          }
        }
      `}</style>
    </>
  );
};

export default StatisticsCards;
